import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useQuery } from '@tanstack/react-query';

export const GET_MATCH_SCORES_QUERY_KEY = 'assets.getMatchScores';

export const useGetMatchScores = ({
  sourceAssetId,
  targetAssetId,
  assetTenantId,
  enabled = true,
}: {
  sourceAssetId?: string;
  targetAssetId?: string;
  assetTenantId?: string;
  enabled?: boolean;
}) => {
  const { getTenantId } = useTenants();
  const tenantId = assetTenantId ?? getTenantId();
  const { data, isLoading, error } = useQuery({
    queryKey: [GET_MATCH_SCORES_QUERY_KEY, { sourceAssetId, targetAssetId, tenantId }],
    queryFn: () => api.assets.getMatchScores(tenantId, sourceAssetId ?? '', targetAssetId ?? ''),
    enabled: !!sourceAssetId && !!targetAssetId && !!tenantId && enabled,
    retry: false,
  });

  return {
    matchScores: data?.data,
    isLoading,
    error,
  };
};
